export default __webpack_public_path__ + "static/media/information-circle.e896e7e9.svg";